/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import OffBoardingPresenter from "./OffBoardingPresenter";
import Shell from "../../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOOffBoarding from "./DTOOffBoarding";
import { useTranslation } from "react-i18next";

function OffBoardingController() {
  const [offBoardingList, setOffBoardingList] = useState([]);
  const [, setOffBoardingWithdrawn] = useState([]);
  const { t, i18n } = useTranslation();

  const getOffboardinglist = (data: any) => {
    setOffBoardingList(data);
  };

  const getOffboardingWithdrawn = (data: any) => {
    setOffBoardingWithdrawn(data);
  };

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DTOOffBoarding
          setOffBoardingListData={getOffboardinglist}
          setOffBoardingWithdrawnData={getOffboardingWithdrawn}
        />
        <OffBoardingPresenter
          storeOffboardingList={offBoardingList}
          trans={t}
          i18n={i18n}
          // storeOffboardingWithdrawn={offBoardingWithdrawn}
        />
      </Grid>
    </Shell>
  );
}
export default OffBoardingController;
